import {
  GiAllSeeingEye,
  GiBabyFace,
  GiBrassEye,
  GiBurningEye,
  GiChewedHeart,
  GiClown,
  GiCrownedSkull,
  GiDefibrilate,
  GiDelighted,
  GiDramaMasks,
  GiEyeball,
  GiGolemHead,
  GiHeartburn,
  GiInvisibleFace,
  GiIronMask,
  GiMechaMask,
  GiMorbidHumour,
  GiMountedKnight,
  GiOppositeHearts,
  GiOverlordHelm,
  GiPawn,
  GiPharoah,
  GiPiercedHeart,
  GiSurroundedEye,
  GiWitchFace,
} from "react-icons/gi";
import { Colors } from "./colors";

export const DEFAULT_SKILL_ICON_SIZE = 60;

export const Constants = {
  PWA: {
    SHOW_IOS_INSTALL_PROMPT_MODEL_QUERY_PARAM: "show_ios_pwa_install_prompt",
  },
  SKILLS: {
    Dominance: {
      name: "Dominance",
      value: "dominance",
      displayOrder: 4,
      color: Colors.GAME_BADGE_YELLOW,
      stages: {
        1: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiPawn({ size, color: Constants.SKILLS.Dominance.color }),
          description:
            "You’re learning how to own space and carry yourself with authority.",
        },
        2: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiMountedKnight({ size, color: Constants.SKILLS.Dominance.color }),
          description: "You speak less, yet command more respect than others.",
        },
        3: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiCrownedSkull({ size, color: Constants.SKILLS.Dominance.color }),
          description:
            "You’re naturally in charge without forcing it—people follow your lead.",
        },
        4: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiPharoah({ size, color: Constants.SKILLS.Dominance.color }),
          description:
            "Whether in dating or life, people trust your direction and compete for your attention.",
        },
        5: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiOverlordHelm({ size, color: Constants.SKILLS.Dominance.color }),
          description:
            "The highest form of masculine dominance—you are the prize wherever you go.",
        },
      },
    },
    Flirt: {
      name: "Flirt",
      value: "flirt",
      color: Colors.GAME_BADGE_PINK_RED,
      displayOrder: 3,
      stages: {
        1: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiChewedHeart({ size, color: Constants.SKILLS.Flirt.color }),
          description:
            "You’re learning to be playful & fun without being awkward.",
        },
        2: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiOppositeHearts({ size, color: Constants.SKILLS.Flirt.color }),
          description:
            "Your flirting feels natural, and you know how to create playful chemistry.",
        },
        3: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiPiercedHeart({ size, color: Constants.SKILLS.Flirt.color }),
          description:
            "You can push, pull, tease, and escalate smoothly—no hesitation.",
        },
        4: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiDefibrilate({ size, color: Constants.SKILLS.Flirt.color }),
          description:
            "You control attraction effortlessly, making interactions electrifying.",
        },
        5: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiHeartburn({ size, color: Constants.SKILLS.Flirt.color }),
          description:
            "Women feel an undeniable pull toward you—your energy creates anticipation.",
        },
      },
    },
    Humor: {
      name: "Humor",
      value: "humor",
      color: Colors.GAME_BADGE_TEAL,
      displayOrder: 2,
      stages: {
        1: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiClown({ size, color: Constants.SKILLS.Humor.color }),
          description:
            "You’re learning to tease & banter, but sometimes you miss the mark. Keep refining.",
        },
        2: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiDelighted({ size, color: Constants.SKILLS.Humor.color }),
          description:
            "Your comebacks are faster. You’re never caught off guard when teased.",
        },
        3: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiMorbidHumour({ size, color: Constants.SKILLS.Humor.color }),
          description:
            "You naturally inject humor into conversations, making them engaging & memorable.",
        },
        4: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiDramaMasks({ size, color: Constants.SKILLS.Humor.color }),
          description:
            "Your humor creates attraction effortlessly, and women crave your presence.",
        },
        5: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiWitchFace({ size, color: Constants.SKILLS.Humor.color }),
          description:
            "You’re on legendary levels—your words create deep emotional impact & charm.",
        },
      },
    },
    Frame: {
      name: "Frame",
      value: "frame",
      color: Colors.GAME_BADGE_CREAM,
      displayOrder: 1,
      stages: {
        1: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiBabyFace({ size, color: Constants.SKILLS.Frame.color }),
          description:
            "You’re learning how to keep your cool under light pressure, standing firm in conversations.",
        },
        2: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiInvisibleFace({ size, color: Constants.SKILLS.Frame.color }),
          description:
            "Tests are getting trickier, but you’re unfazed—learning to deflect, reframe, and control the narrative.",
        },
        3: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiIronMask({ size, color: Constants.SKILLS.Frame.color }),
          description:
            "You now dictate the pace of interactions. Your frame is natural, and people look to you for leadership.",
        },
        4: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiGolemHead({ size, color: Constants.SKILLS.Frame.color }),
          description:
            "Women’s hardest challenges bounce off you. You pass frame battles without effort.",
        },
        5: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiMechaMask({ size, color: Constants.SKILLS.Frame.color }),
          description:
            "The highest level. You bend social interactions to your will—you set the frame, always.",
        },
      },
    },
    Signals: {
      name: "Signals",
      value: "signals",
      color: Colors.GAME_BADGE_BLUE,
      displayOrder: 5,
      stages: {
        1: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiBrassEye({ size, color: Constants.SKILLS.Signals.color }),
          description:
            "You’re learning to decode microexpressions & small cues.",
        },
        2: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiEyeball({ size, color: Constants.SKILLS.Signals.color }),
          description:
            "You recognize IOIs (Indicators of Interest) and disinterest almost instantly.",
        },
        3: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiBurningEye({ size, color: Constants.SKILLS.Signals.color }),
          description:
            "You know when to push, pull, or leave based on real-time feedback.",
        },
        4: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiSurroundedEye({ size, color: Constants.SKILLS.Signals.color }),
          description:
            "Nothing slips past you—you see what people actually mean, not just what they say.",
        },
        5: {
          icon: (size: number = DEFAULT_SKILL_ICON_SIZE) =>
            GiAllSeeingEye({ size, color: Constants.SKILLS.Signals.color }),
          description:
            "Your awareness is next level—you read the room like a chess master sees the board.",
        },
      },
    },
  },
  SCENARIOS: [
    {
      id: 1,
      name: "School Library",
      imageUrl: "https://cdn.manupgame.com/scenario-school-library.png",
      imagePosition: "center_70%",
      difficulty: "easy",
      isLongStory: false,
      isProOnly: false,
      isUnlocked: true,
      briefing: {
        objectives: ["Get her number"],
        targetPersona:
          "Smart, reserved, low tolerance for BS. She's focused and doesn't like being interrupted.",
        context:
          "You just spotted her across the library — hoodie up, headphones in, but cute. You’re curious and want to break the ice without coming off as a creep.",
      },
    },
    {
      id: 2,
      name: "Coffee Shop",
      imageUrl: "https://cdn.manupgame.com/scenario-coffee-shop.png",
      imagePosition: "center_70%",
      difficulty: "medium",
      isLongStory: true,
      isProOnly: false,
      isUnlocked: true,
      briefing: {
        objectives: ["Get her Instagram", "Make her laugh"],
        targetPersona:
          "Chill, artsy, probably a reader. She notices things, but pretends not to. Likes playful energy but gets bored fast.",
        context:
          "You’re both waiting for coffee. She's ahead of you, and there’s an energy — like maybe she wants you to say something. Or maybe not. Your move.",
      },
    },
    {
      id: 3,
      name: "Gym",
      imageUrl: "https://cdn.manupgame.com/scenario-gym.jpg",
      imagePosition: "center_70%",
      difficulty: "medium",
      isLongStory: true,
      isProOnly: false,
      isUnlocked: true,
      briefing: {
        objectives: ["Get her attention", "Spark future conversation"],
        targetPersona:
          "Focused, strong-willed, probably tired of creepy gym guys. She's there to train, not to flirt — unless it's worth it.",
        context:
          "You’ve seen her around the gym. Today, you catch a small glance in the mirror. Is that interest, or just your ego? You only get one clean shot.",
      },
    },
    {
      id: 4,
      name: "Office",
      imageUrl: "https://cdn.manupgame.com/scenario-work.jpg",
      imagePosition: "center_70%",
      difficulty: "medium",
      isLongStory: true,
      isProOnly: true,
      isUnlocked: true,
      briefing: {
        objectives: ["Build rapport", "Set up future hangout"],
        targetPersona:
          "Smart, professional, knows office politics. She’s friendly but guarded, especially at work.",
        context:
          "You’re working late. She’s the only other one around. Casual chat turns into playful banter. It’s a fine line between tension and professionalism — can you walk it?",
      },
    },
    {
      id: 5,
      name: "Wedding",
      imageUrl: "https://cdn.manupgame.com/scenario-wedding.png",
      imagePosition: "object-[center_65%]",
      difficulty: "medium",
      isLongStory: true,
      isProOnly: true,
      isUnlocked: true,
      briefing: {
        objectives: ["Dance with her", "Get her number before the night ends"],
        targetPersona:
          "Social, flirtatious, loves attention. She’s here to have fun — but she’s being chased by other guys too.",
        context:
          "It’s a wedding. Good music, drinks flowing, and she’s already laughed at one of your comments. Can you stand out before the bouquet hits the floor?",
      },
    },
    {
      id: 6,
      name: "Bar",
      imageUrl: "https://cdn.manupgame.com/scenario-bar.jpg",
      imagePosition: "object-[center_35%]",
      difficulty: "hard",
      isLongStory: true,
      isProOnly: true,
      isUnlocked: true,
      briefing: {
        objectives: ["Pull her aside", "Get her number without seeming needy"],
        targetPersona:
          "High energy, attention from every direction. She’s used to guys shooting their shot and failing.",
        context:
          "The music’s loud, the lighting’s low, and she’s holding court near the bar. If you want this to go anywhere, you’ll need more than just charm — you’ll need timing, confidence, and zero hesitation.",
      },
    },
  ],
  GAME: {
    SCORING: {
      BASE_SKILL_XP: 10,
      DIFFICULTY_MULTIPLIER: {
        Easy: 1,
        Medium: 1.5,
        Hard: 2,
      },
      STREAK_MULTIPLIER: {
        TWO_DAYS: 1.1,
        FIVE_DAYS: 1.2,
        TEN_DAYS: 1.4,
      },
    },
  },
};
